import React from "react";
import { FaLinkedinIn, FaReact, FaGithub, FaTelegram } from "react-icons/fa";
import { SiTailwindcss, SiNextdotjs, SiTypescript } from "react-icons/si";
const Media = ({ show, text }) => {
  return (
    <div className="flex flex-col xl:flex-row justify-between xl:gap-16">
      <div className="mb-4">
        {text && (
          <h3 className="mb-4 text-base uppercase font-titleFont">{text}</h3>
        )}
        <div className="flex items-center space-x-5">
          <a href="https://www.linkedin.com/in/iman-saadat/">
            <span className="mediaIcon">
              <FaLinkedinIn />
            </span>
          </a>
          <a href="https://github.com/imansaadat">
            <span className="mediaIcon">
              <FaGithub />
            </span>
          </a>
          <a href="https://t.me/imansaadat72">
            <span className="mediaIcon">
              <FaTelegram />
            </span>
          </a>
        </div>
      </div>
      {show && (
        <div>
          <h3 className="mb-4 text-base uppercase font-titleFont">
            best skill on
          </h3>
          <div className="flex items-center space-x-5">
            <a href="https://react.dev/">
              <span className="mediaIcon">
                <FaReact />
              </span>
            </a>
            <a href="https://nextjs.org/">
              <span className="mediaIcon">
                <SiNextdotjs />
              </span>
            </a>
            <a href="https://www.typescriptlang.org/">
              <span className="mediaIcon">
                <SiTypescript />
              </span>
            </a>
            <a href="https://tailwindcss.com/">
              <span className="mediaIcon">
                <SiTailwindcss />
              </span>
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default Media;
